import { object } from 'yup';

import { email } from '@/constants';

export const siteSettingsSchema = object({
  adminEmail: email.notRequired(),
  recruiterEmail: email.notRequired(),
}).required();
